module.exports = fox => {
	require('./_shortcuts-bootstraper.styl');
}


// WEBPACK FOOTER //
// ../common/dependencies/index.es.js